module.exports = __webpack_public_path__ + "img/ico_pls_no.1e320c3e.svg";